module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event/event_jewelry-16d43b3f8fdf297685fc620d1ee58ab2.jpg";